// extracted by mini-css-extract-plugin
export default {"videoLinks":"VideoLinks_videoLinks__Xv05k"};